// Main.js
import React from 'react';
import { Container, Box } from '@mui/material';
import { Element } from 'react-scroll';
import Home from './Home';
import AppBar from './AppBar';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import About from './About'; // Import your components
import Contact from './Contact';
import Join from './Join';
import Donate from './Donate';
import NewsReleases from './NewsReleases';
import Social from './Social';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Main = (props) => {
    const user = props.user;

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
        <AppBar user={user} />
        <br />
        <br />
        <br />
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', color: 'white' }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="tabs"
                    centered
                    textColor="inherit"
                    indicatorColor="secondary"
                  >
                    <Tab label="Main" {...a11yProps(0)} sx={{ color: 'white' }} />
                    <Tab label="Social Media" {...a11yProps(1)} sx={{ color: 'white' }} />
                  </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <Box sx={{ pt: 0, mt: -5 }}>
                {/* About Section */}
                <Element name="home">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <Home />
                    <hr />
                    </Container>
                </Box>
                </Element>

                {/* About Section */}
                <Element name="about">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <About />
                    </Container>
                </Box>
                </Element>

                {/* Contact Section */}
                <Element name="contact">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <Contact />
                    </Container>
                </Box>
                </Element>

                {/* Join Section */}
                <Element name="join">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <Join />
                    </Container>
                </Box>
                </Element>

                {/* Donate Section */}
                <Element name="donate">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <Donate />
                    </Container>
                </Box>
                </Element>

                {/* News Releases Section */}
                <Element name="news-releases">
                <Box sx={{ minHeight: '20vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <NewsReleases />
                    </Container>
                </Box>
                </Element>
            </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                {/* Social Releases Section */}
                <Element name="social">
                <Box sx={{ minHeight: '100vh', py: 4 }}>
                    <Container maxWidth="lg">
                    <Social />
                    </Container>
                </Box>
                </Element>
            </CustomTabPanel>
        </Box>
        </div>
    );
};

export default Main;